import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { CallType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";
import { getCallTypeColor } from "utils/cargoActionUtils";

const CallTypeSelect = <Multiple extends boolean = false,>({
	disabled = false,
	value,
	onChange,
	clearable = false,
	additionalOptions = [],
	getOptionDisabled,
	multiple,
}: Pick<SelectProps<CallType, Multiple>, "value" | "onChange" | "getOptionDisabled" | "clearable" | "disabled" | "multiple"> & { options?: CallType[], additionalOptions?: CallType[] }) => {

	const properOrder = [ CallType.NitrogenPurging, CallType.Loading, CallType.Discharging, CallType.LoadingDischarging, CallType.Cleaning ];
	const options = [ ...new Set([ CallType.Discharging, CallType.Loading, ...additionalOptions ]) ]
		.sort((a, b) => properOrder.indexOf(a) - properOrder.indexOf(b));

	return (
		<Select
			multiple={multiple}
			getOptionDisabled={getOptionDisabled}
			disabled={disabled}
			fetchOptions={options}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			getOptionColor={getCallTypeColor}
			value={value}
			onChange={onChange}
			clearable={clearable}
			disableSearch />
	);
};

export default CallTypeSelect;
